export default "__VITE_ASSET__3f435a79__"